import wav1 from "../images/about/wav-1.png";
import wav2 from "../images/about/wav-2.png";
import wav3 from "../images/about/wav-3.png";
import wav4 from "../images/about/wav-4.png";
import wav5 from "../images/about/wav-5.png";
import per1 from "../images/about/per-1.png";
import per2 from "../images/about/per-2.png";
import linkedin from "../images/about/link.svg";
import insta from "../images/about/insta.svg";

const About = () => {
  const teamMembers = [
    {
      name: "Sunil GR",
      role: "Founder & Director",
      desc: "An alumnus of Sainik School and NIT Warangal, Sunil blends 15+ years of IT leadership with a passion for psychology and education. His vision drives Gr8 Appers’ mission to guide students through AI-driven skill assessment and career clarity.",
      image: per1,
      linkedin: "https://www.linkedin.com/in/grsunil",
      instagram: "https://www.instagram.com/grsunilkumar",
    },
    {
      name: "Sudha Varma G",
      role: "Head of Tech",
      desc: "A dynamic technologist with a flair for innovation, Sudha leads the engineering at Gr8 Appers. With a background in full-stack development and a passion for scalable systems, she ensures our AI-driven solutions are robust, efficient, and student-focused. She thrives at the intersection of tech and impact.",
      image: per2,
    },
    // Add more team members as needed
  ];
  return (
    <div className="aboutPage">
      <div className="header">
        <div className="container">
          <h1>About Gr8 Appers</h1>
          <h2>
            Guiding You to a <b>Future</b> That Fits
          </h2>
          <p>
            At Gr8 Appers, we believe that the foundation of every successful
            future lies in understanding who you are — your unique strengths,
            skills, interests, and values. We exist to help students and young
            professionals across India discover their potential and align their
            career paths accordingly.
          </p>
        </div>
        <div className="wav">
          <img src={wav1} alt="Wave 1" className="waveImage waveImage1" />
          <img src={wav2} alt="Wave 2" className="waveImage waveImage2" />
          <img src={wav3} alt="Wave 3" className="waveImage waveImage3" />
          <img src={wav4} alt="Wave 4" className="waveImage waveImage4" />
          <img src={wav5} alt="Wave 5" className="waveImage waveImage5" />
        </div>
      </div>
      <div className="who">
        <div className="container">
          <div className="stickyTitle">
            <h2>Who We Are</h2>
          </div>
          <div className="griddo">
            <div className="full glassCard">
              <p className="mdText">
                We are a team of dedicated professionals committed to helping
                you achieve your career goals. Our expertise lies in career
                counseling, skill development, and personalized guidance.
              </p>
              <p className="mdText">
                Gr8 Appers is an AI-powered platform designed to provide Skill
                Assessment and Career Counseling tailored for today's students.
                In a world overwhelmed by choices, we bring clarity, structure,
                and direction to your academic and professional decisions.
              </p>
            </div>
            <div className="half glassCard mission">
              <h4>🎯 Our Mission</h4>
              <p className="mdText">
                To empower students and young adults with the clarity and
                confidence to make informed career decisions — through
                personalized assessments, counseling, and actionable insights.
              </p>
            </div>
            <div className="half glassCard vision">
              <h4>👁️ Our Vision</h4>
              <p className="mdText">
                To become India’s most trusted career discovery and guidance
                platform — helping learners everywhere take the right step
                forward with purpose and direction.
              </p>
            </div>
            <div className="half glassCard mission">
              <h4>💬 Why It Matters</h4>
              <p className="mdText">
                Every year, countless students end up in the wrong courses or
                careers due to pressure, misinformation, or lack of guidance. At
                Gr8 Appers, we’re changing that — by making career clarity
                accessible, data-driven, and empowering.
              </p>
            </div>
            <div className="half glassCard mission">
              <h4>🤝 Our Promise</h4>
              <p className="mdText">
                We don’t just hand over a report — we walk with you on your
                journey. Whether you're a student unsure of what stream to take,
                a graduate looking for direction, or a parent wanting the best
                for your child, Gr8 Appers ensures that every application, every
                decision, and every move is a confident step forward.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="team">
        <div className="container">
          <div className="peopleList">
            {teamMembers.map((member, index) => (
              <div className="person glassCard">
                <div className="baseDetail" key={index}>
                  <img src={member.image} alt={member.name} />
                  <div className="desc">
                    <h4 className="name">{member.name}</h4>
                    <p className="role">{member.role}</p>
                    {member.linkedin || member.instagram ? (
                      <p className="socialLinks">
                        {member.linkedin && (
                          <a
                            href={member.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={linkedin} alt="LinkedIn" />
                          </a>
                        )}
                        {member.instagram && (
                          <a
                            href={member.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src={insta} alt="Instagram" />
                          </a>
                        )}
                      </p>
                    ) : null}
                  </div>
                </div>
                <p className="mdText">
                  {member.desc}
                </p>
              </div>
            ))}
          </div>
          <div className="aboutTeam">
            <h3>
              Guiding Minds. Shaping <b>Bright Futures.</b>
            </h3>
            <p>
              At Gr8 Appers, our strength lies in the passion and purpose of the
              people behind the platform. We’re a diverse team of career
              coaches, psychologists, educators, designers, and technologists
              united by a shared mission — to help students discover their
              best-fit futures.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
